import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import { isValuePoint } from "fond/types/geojson";

import CustomSnapPointMode from "./snap/CustomSnapPointMode";
import { removeGuides } from "./helper";

const { constants: Constants } = MapboxDraw;

/*
 * A modified draw_point mode that stays in draw_point when a point is created,
 * rather than moving back to simple_select and requiring the user to re-enter
 * draw point mode to create the next point.
 */
const drawPoint: DrawCustomMode = {
  ...CustomSnapPointMode,

  onSetup: function (opts) {
    const state = CustomSnapPointMode.onSetup?.call(this, opts);
    // Determine whether to allow multiple points to be drawn in a single session based on the multiCreate option
    state.multiCreate = opts.multiCreate ?? true;
    removeGuides.call(this);

    return state;
  },

  onClick: function (this, state) {
    state.point.updateCoordinate("", state.snappedLng, state.snappedLat);

    this.map.fire(Constants.events.CREATE, {
      features: [state.point.toGeoJSON()],
    });

    if (!state.multiCreate) {
      this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.point.id] });
    } else {
      // We trigger the changeMode to DRAW_POINT again to stay in draw mode after creating a point,
      // instead of switching back to simple_select.
      this.changeMode(Constants.modes.DRAW_POINT);
    }
  },

  onStop(state) {
    this.activateUIButton();
    if (!isValuePoint(state.point.toGeoJSON())) {
      this.deleteFeature([state.point.id], { silent: true });
    }
    // Always call parent onStop to clean up snap-mode event listeners
    CustomSnapPointMode.onStop?.call(this, state);
  },
};

export default drawPoint;
